// Format date to Api dd/mm/yyyy
export const formatDateToApiString = (
  date: Maybe<Date>
): string | undefined => {
  if (!date) {
    return
  }

  const dateObj = new Date(date)

  return `${dateObj.getDate()}/${
    dateObj.getMonth() + 1
  }/${dateObj.getFullYear()}`
}

// Format Api yyyy-mm-dd to Date(dd/mm/yyyy)
export const formatApiStringToDate = (
  date: Maybe<string>
): Date | undefined => {
  if (!date) {
    return
  }

  const dateArray = date.split('-')
  if (dateArray.length !== 3) {
    return
  }
  const dateString = `${dateArray[1]}/${dateArray[2]}/${dateArray[0]}`

  return new Date(dateString)
}

// format iso string to dd/mm/yyyy
export const formatDateShort = (date: Date | string): string => {
  const validDate = typeof date === 'string' ? new Date(date) : date
  const day = `${validDate.getDate()}`.padStart(2, '0')
  const month = `${validDate.getMonth() + 1}`.padStart(2, '0')
  const year = validDate.getFullYear()
  return `${day}/${month}/${year}`
}
